module.exports = __webpack_public_path__ + "img/tumblr_p74hqlw7n51sfoms5o1_500.jpg";